<template>
    <div v-if="noticeData">
      <ul class="cs-2depth">
        <li @click="goSubTab('all')" :class="setTabCss('all')"><button>전체</button></li>
        <li @click="goSubTab('service')" :class="setTabCss('service')"><button>서비스공지</button></li>
        <li @click="goSubTab('contents')" :class="setTabCss('contents')"><button>콘텐츠공지</button></li>
      </ul>

      <div class="cs-table02-wrap">
        <form class="noti-search">
          <fieldset>
            <legend>공지사항 검색 양식</legend>
            <input type="text" v-model="searchWord" @keydown.enter.prevent="goSearchWord()"
                   placeholder="궁금하신 점을 입력해 주세요" />
            <button type="button" @click="goSearchWord()" class="noti-search-btn">검색</button>
          </fieldset>
        </form>

        <table class="cs-table-02">
          <caption>공지사항 리스트 </caption>
          <colgroup>
            <col style="width: 139px;">
            <col>
            <col style="width: 139px;">
          </colgroup>
          <thead>
          <tr>
            <th>구분</th>
            <th>제목</th>
            <th>등록일</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><p class="noti-date">{{noticeData.noticetypetext}}</p></td>
            <td><p class="noti-detail-title">{{noticeData.noticetitle}} <img v-if="noticeData.isNew==='y'" src="../../assets/images/customer/tag-new.png" alt="새로운글" style="width: 44px;" /></p></td>
            <td><p class="noti-date">{{noticeData.regdate}}</p></td>
          </tr>
          </tbody>
        </table>

        <div class="noti-detail-wrap" v-html="setEnterChange(contentData)"></div>
         <div class="noti-d-btn-wrap">
           <div class="noti-d-btn">
             <a href="#" @click.prevent="goDetailPage(noticeData.prev.noticeid)">
               <span class="noti-d-text">이전글</span>
               <strong v-if="noticeData.prev.noticetitle" class="noti-d-tit">{{noticeData.prev.noticetitle}}</strong>
               <strong v-else class="noti-d-tit">이전글이 없습니다.</strong>
               <span class="noti-d-date">{{noticeData.prev.regdate}}</span>
             </a>
           </div>

           <div class="noti-d-btn">
             <a href="#" @click.prevent="goDetailPage(noticeData.next.noticeid)">
               <span class="noti-d-text">다음글</span>
               <strong v-if="noticeData.next.noticetitle" class="noti-d-tit">{{noticeData.next.noticetitle}}</strong>
               <strong v-else class="noti-d-tit">다음글이 없습니다.</strong>
               <span class="noti-d-date">{{noticeData.next.regdate}}</span>
             </a>
           </div>
         </div><!--noti-btn-wrap//-->

        <div class="list-btn">
          <a href="#" @click.prevent="goListPage()"><img src="../../assets/images/customer/list-btn.png" alt=""/><span>목록</span></a>
        </div>
      </div>

    </div>
</template>

<script>
import { getNoticesDetail } from '@/common/utils/request'
import { setEnterChange, scrollTop, titleTagNameChange } from '@/common/utils/common'
import queryString from '@/common/utils/querystring'
import _ from 'lodash'
export default {
  data () {
    return {
      data: true, // 임시 웨이브온 flag 값
      noticeData: undefined,
      filterType: queryString.getQueryParamValue(this.$route, 'filterType', 'all'),
      searchWord: queryString.getQueryParamValue(this.$route, 'searchWord'),
      noticeId: queryString.getQueryParamValue(this.$route, 'noticeId'),
      currentPage: +queryString.getQueryParamValue(this.$route, 'page', '1')
    }
  },
  computed: {
    contentData () {
      return this.noticeData.content
    }
  },
  methods: {
    // SubTab CSS 설정
    setTabCss (index) {
      return this.filterType === index ? 'cs-2depth-on' : ''
    },
    // 엔터 기호 변경
    setEnterChange (content) {
      return setEnterChange(content)
    },
    // SubTab 선택 페이지 이동
    goSubTab (index) {
      this.$router.push({
        name: 'notice_list',
        query: {
          filterType: index
        }
      })
    },
    // 검색어 조회 페이지 이동
    goSearchWord () {
      this.$router.push({
        name: 'notice_list',
        query: {
          filterType: this.filterType,
          searchWord: this.searchWord
        }
      })
    },
    // 공지사항 상세 페이지 이동
    goDetailPage (noticeId) {
      if (!noticeId) return
      this.$router.push({
        query: {
          filterType: this.filterType,
          noticeId: noticeId,
          pageNum: this.currentPage,
          searchWord: this.searchWord
        }
      })
    },
    // 공지사항 리스트 페이지 이동
    goListPage () {
      this.$router.push({
        name: 'notice_list',
        query: {
          filterType: this.filterType,
          pageNum: this.currentPage,
          searchWord: this.searchWord
        }
      })
    },
    getNoticesDetailInfo () {
      getNoticesDetail({ noticeid: this.noticeId }).then((response) => {
        this.noticeData = response.data
        titleTagNameChange(`${_.get(this.noticeData, 'noticetitle', '공지사항')} : 웨이브 고객센터`)
      })
    }
  },
  created () {
    scrollTop()
    this.getNoticesDetailInfo()
  },
  watch: {
    $route (to, from) {
      this.noticeId = _.get(this.$route, ['query', 'noticeId'], '')
      this.noticeData = null
      this.getNoticesDetailInfo()
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>
<style lang="scss" src="@/assets/scss/category/service.scss"></style>
